import { Dropdown } from 'antd';
import React, { Fragment } from 'react';
import { CustomDatePicker, RangeValue } from '../common/DatePicker';
import moment from 'moment';

interface Props {
    daysFilter: () => JSX.Element;
    currTimeFilter?: string;
    dates: RangeValue<moment.Moment> | undefined;
    setDates: ((dates?: RangeValue<moment.Moment> | undefined) => void) | undefined;
    setTimeFilter: (startDate: string, endDate: string) => void;
    datePickerDisabled?: boolean;
    enableFuture?: boolean;
    noOfDays: number;
}

const DateFilter: React.FC<Props> = (props) => {
    const {
        daysFilter,
        currTimeFilter = '-',
        dates,
        setDates,
        setTimeFilter,
        datePickerDisabled = false,
        enableFuture = false,
        noOfDays,
    } = props;
    return (
        <Fragment>
            <Dropdown overlay={daysFilter()} placement="bottomLeft" trigger={['click']}>
                <div className="bg-darwin-neutral_new-50 cursor-pointer h-36 py-6 flex items-center gap-8 text-neutral-black font-400 text-13 justify-between px-8 rounded-8">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4 6.3125C4 5.59375 4.5625 5 5.28125 5H18.6875C19.4062 5 20 5.59375 20 6.3125C20 6.625 19.875 6.90625 19.6875 7.125L14.5 13.5312V18C14.5 18.5625 14.0312 19 13.4688 19C13.25 19 13.0312 18.9375 12.8438 18.7812L9.96875 16.5C9.65625 16.25 9.5 15.9062 9.5 15.5312V13.5312L4.28125 7.125C4.09375 6.90625 4 6.625 4 6.3125ZM5.6875 6.5L10.8125 12.7812C10.9375 12.9375 11 13.0938 11 13.25V15.4062L13 17V13.25C13 13.0938 13.0312 12.9375 13.1562 12.7812L18.2812 6.5H5.6875Z"
                            fill="#1A1A1A"
                        />
                    </svg>
                    <p className="font-700 text-13">{currTimeFilter}</p>
                    <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.2812 1.45703L6.43164 6.10352C6.2793 6.23047 6.12695 6.28125 6 6.28125C5.84766 6.28125 5.69531 6.23047 5.56836 6.12891L0.693359 1.45703C0.439453 1.22852 0.439453 0.822266 0.667969 0.59375C0.896484 0.339844 1.30273 0.339844 1.53125 0.568359L6 4.83398L10.4434 0.568359C10.6719 0.339844 11.0781 0.339844 11.3066 0.59375C11.5352 0.822266 11.5352 1.22852 11.2812 1.45703Z"
                            fill="#1A1A1A"
                        />
                    </svg>
                </div>
            </Dropdown>

            <CustomDatePicker
                dates={dates}
                setDates={setDates}
                onDatesSelected={setTimeFilter}
                noOfDays={noOfDays}
                enableFuture={enableFuture}
                className="rounded-8 w-230"
                size="small"
                newDesign={true}
                disabled={datePickerDisabled}
                separatorIcon={
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        className="fill-darwin-neutral-400"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M8.25 1.21875L13.75 6.46875C13.9062 6.625 14 6.8125 14 7.03125C14 7.21875 13.9062 7.40625 13.75 7.5625L8.25 12.8125C7.96875 13.0938 7.46875 13.0938 7.1875 12.7812C6.90625 12.5 6.90625 12 7.21875 11.7188L11.375 7.78125H0.75C0.3125 7.78125 0 7.4375 0 7.03125C0 6.59375 0.3125 6.28125 0.75 6.28125H11.375L7.21875 2.3125C6.90625 2.03125 6.90625 1.53125 7.1875 1.25C7.46875 0.9375 7.9375 0.9375 8.25 1.21875Z" />
                    </svg>
                }
            />
        </Fragment>
    );
};

export default DateFilter;
